
import React from "react";
import { i18nManager } from "../i18n";
import { LzEncryptor, CacheManager } from "../utils";
import { useNavigate, useSearchParams } from "react-router-dom";

function Authenticate() {
    const navigate = useNavigate();
    const labels = i18nManager.Labels.authenticate;
    const [searchParams, _] = useSearchParams(window.location.search);

    React.useEffect(() => {
        if (!searchParams.has("atok")) {
            navigate("/");
            return;
        }
        const encryptedAuthorizationToken = searchParams.get("atok") ?? "";
        const authorizationToken = LzEncryptor.decrypt(decodeURIComponent(encryptedAuthorizationToken), true);
        if (!authorizationToken) {
            navigate("/");
            return;
        }
        CacheManager.clear();
        CacheManager.insecurePut(CacheManager.ACCESS_TOKEN_KEY, authorizationToken);
        navigate("/dashboard");
    }, []);

    return (<div>
        {labels.redirecting}
    </div>);
}

export default Authenticate;
